<div class="container mx-auto mt-5 px-4">
  <h2 class="text-3xl font-semibold text-center my-5">Estudiantes</h2>
  <div class="flex justify-between items-center mb-4">
    <button
      (click)="volver()"
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
    >
      Volver
    </button>
    <button
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      (click)="goToCreateEstudiantes()"
    >
      Subir Estudiantes
    </button>
    <button
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      (click)="openCreateModal()"
    >
      Registrar Estudiante
    </button>
  </div>
  <app-table
    [data]="estudiantes"
    [columns]="columns"
    [actions]="actions"
    searchPlaceholder="Buscar estudiantes..."
  ></app-table>

  <!-- Modal para editar estudiante -->
  <app-item-modal
    [isOpen]="showModal"
    [item]="selectedItem"
    [title]="'Editar Estudiante'"
    [fields]="fields"
    (close)="closeModal()"
    (save)="saveChanges($event)"
  ></app-item-modal>

  <!-- Modal para crear estudiante -->
  <app-create-modal
    [isOpen]="showCreateModal"
    [title]="'Registrar Estudiante'"
    [fields]="fieldsCreate"
    [item]="studentData"
    (close)="closeCreateModal()"
    (save)="createStudent($event)"
  ></app-create-modal>
</div>
